export enum TrackActionTypes {
  TRACK_EVENT = 'TRACK_EVENT',
  TRACK_LINK = 'TRACK_LINK',
}

export const trackEvent = (event: string) => ({
  type: TrackActionTypes.TRACK_EVENT,
  payload: event,
});

export interface TrackLinkAction {
  type: string;
  payload?: string;
  meta: {
    metrics: {
      link?: string;
    };
  };
}

export type TrackLink = (link?: string) => TrackLinkAction;

export const trackLink: TrackLink = (link) => ({
  type: TrackActionTypes.TRACK_LINK,
  payload: link,
  meta: {
    metrics: { link },
  },
});
